import styles from './ImageSection.module.scss'
import { useState } from 'react'
import NextLink from 'next/link'
import NextImage from 'next/image'
import { IFeedRecord } from '@/interfaces/IFeedRecord'
import imageService from '@/modules/imageService/client'

interface ImageSectionProps {
  record: IFeedRecord
}

function ImageSection ({ record }: ImageSectionProps) {
  const [imageLoaded, setImageLoaded] = useState(false)
  return (
    <>
      {record.image &&
        <NextLink
          href={`/${record.slug}`}
        >
          <div className={`${styles.recordImageWrapper} ${!imageLoaded ? styles.loading : ''}`}>
            <NextImage
              src={imageService.postImageURL(record.id, record.image)}
              alt="placeholder"
              width={450}
              height={450}
              className={`${styles.recordImage} ${!imageLoaded ? styles.recordImageHidden : ''}`}
              onLoadingComplete={() => setImageLoaded(true)}
              onError={() => setImageLoaded(true)}
            />
          </div>
        </NextLink>
      }
    </>
  )
}

export default ImageSection
